import React from 'react';
import { Route } from 'react-router';
export default (
  <Route
    path="employee/(:departmentId)"
    getComponent={(Location, callback) => {
      require.ensure([], (require) => {
        callback(null, require('./index'));
      });
    }}
  />
);



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/containers/App/screens/Tube/screens/PeopleSearch/screens/List/screens/UnderDepartment/router.js
 **/